module.exports = __webpack_public_path__ + "img/bg-bzsz.3a89927d.png";